import { render, staticRenderFns } from "./VideoIframe.vue?vue&type=template&id=0df6953c&scoped=true&"
import script from "./VideoIframe.vue?vue&type=script&lang=ts&"
export * from "./VideoIframe.vue?vue&type=script&lang=ts&"
import style0 from "./VideoIframe.vue?vue&type=style&index=0&id=0df6953c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df6953c",
  null
  
)

export default component.exports